import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { NaamIcon } from "../../atoms/icons/NaamIcon";

// All the incoming values
interface IProps {
    firstName?: string | null;
    lastName?: string | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string | null>, 'value'>;
export const Naam = (props: AllProps) => {
    const fullName = [props.firstName, props.lastName].filter(Boolean).join(' ') || '-';
    
    return (<Caption {...props} caption={props.label || "Naam"} icon={<NaamIcon />}>
        {fullName}
    </Caption>)
}
